export var ShopSymbol;
(function (ShopSymbol) {
    ShopSymbol["UNKNOWN"] = "Unknown";
    ShopSymbol["PURCHASABLE"] = "Purchasable";
    ShopSymbol["UNAVAILABLE"] = "Unavailable";
    ShopSymbol["INCLUDED"] = "Included";
})(ShopSymbol || (ShopSymbol = {}));
export var SliceDirection;
(function (SliceDirection) {
    SliceDirection["Outbound"] = "Outbound";
    SliceDirection["Return"] = "Return";
})(SliceDirection || (SliceDirection = {}));
export var TripGrouping;
(function (TripGrouping) {
    TripGrouping["DATE"] = "DateGrouping";
})(TripGrouping || (TripGrouping = {}));
export var DisruptionProtectionQueryParam;
(function (DisruptionProtectionQueryParam) {
    DisruptionProtectionQueryParam["ItineraryId"] = "itineraryId";
    DisruptionProtectionQueryParam["SliceIndex"] = "sliceIndex";
    DisruptionProtectionQueryParam["SegmentIndex"] = "segmentIndex";
    DisruptionProtectionQueryParam["Origin"] = "origin";
    DisruptionProtectionQueryParam["Destination"] = "destination";
    // note: these params are for event tracking only
    DisruptionProtectionQueryParam["ProductRedeemChoice"] = "productRedeemChoice";
    DisruptionProtectionQueryParam["ActiveDisruption"] = "activeDisruption";
    DisruptionProtectionQueryParam["EmbeddedRoundTrip"] = "embeddedRoundTrip";
})(DisruptionProtectionQueryParam || (DisruptionProtectionQueryParam = {}));
//# sourceMappingURL=constants.js.map